import { _360IntegrationTypes } from "@/components/constants"
export default {
  projectName: {
    component: "TextFieldSearchFilter",
    offline: true,
  },
  projectId: {
    component: "TextFieldSearchFilter",
    offline: true,
  },
  integrationType: {
    component: "SelectSearchFilter",
    attributes: {
      items: [{ name: "All", value: "" }, ..._360IntegrationTypes],
    },
    offline: true,
  },
}
